import { isProduction } from '..';

interface ShowGitInfoProps {
  appName: string;
  commitHash?: string;
  branchName?: string;
  version?: string;
  tagName?: string;
}

export const showGitInfo = ({
  appName,
  commitHash,
  branchName,
  tagName,
  version,
}: ShowGitInfoProps) => {
  if (!isProduction) return;

  console.log(
    `%c
-------------------------------------------------------
${appName} Git Info:
App Version: ${version}
Commit Hash: ${commitHash}
Branch Name: ${branchName}
Tag Name: ${tagName}
-------------------------------------------------------`,
    'color: purple; font-size: larger; font-weight: bold'
  );
};
